<template>
  <div class="container col-sm-8 center">
    <h1 class="text-center">Welcome to <strong>sipr Project</strong></h1>
    <div class="container col-sm-8 text-center p-5">
      <input v-model="passage" v-on:keyup.enter="searchPassage"><button @click="searchPassage">Study</button>
    </div>
    <h2>Cognates and Lexicography</h2>
    <div class="row">
      <div class="col-sm-4">
        <img style="width: 100%" :src="`${publicPath}cognate_schema.png`" />
      </div>
      <div class="col-sm-8">
        Cognates are lexemes in related languages that are presumed to
        originate from the same source. In the case of the words in the Hebrew
        Bible, the languages are other Semitic languages like Akkadian,
        Aramaic, Arabic or Ugaritic that can be traced to the hypothetical
        proto-Semitic.<br />
        Primary Uses in Lexicography:
        <ul>
          <li>Discovering Lost Meanings</li>
          <li>Refining Etymology</li>
          <li>Distinguishing Homonyms</li>
          <li>Resolving Contextual Difficulties</li>
        </ul>
      </div>
    </div>
    <h2>Online Availability of Akkadian and Aramaic Lexica</h2>
    <div class="row">
      <div class="col-sm-8">
        In the last decades, online scholarly tools have become available
        within the field of the Semitic Languages studies.<br />
        For the initial stage of this project the following two are essential:
        <ul>
          <li>
            <a href="https://cal.huc.edu/">The Comprehensive Aramaic Lexicon</a>
          </li>
          <li>
            <a href="https://www.ebl.lmu.de/">The electronic Babylonian Library</a>
          </li>
        </ul>
      </div>
      <div class="col-sm-4">
        <img style="width: 100%" :src="`${publicPath}cal_ebl_screenshots.png`" />
      </div>
    </div>
    <br />
    <br />
  </div>
</template>

<script>
// import axios from 'axios';

export default {
  name: 'HomeView',
  data() {
    return {
      publicPath: process.env.BASE_URL,
      passage: 'Genesis 1:1',
    }
  },
  props: {
  },
  methods: {
    searchPassage() {
      this.$router.push(this.publicPath + 'passage/' + this.passage);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
  margin-top: 2em;
  margin-bottom: 1em;
}
</style>
